import { render, staticRenderFns } from "./BusinessOpportunityAdmin.vue?vue&type=template&id=a1ae2cbe&scoped=true"
import script from "./BusinessOpportunityAdmin.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunityAdmin.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunityAdmin.vue?vue&type=style&index=0&id=a1ae2cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae2cbe",
  null
  
)

export default component.exports